export class OccupancyRate {

    Date: Date;
    Total:number;

    
}